import React from "react";
import "./CancelDialog.scss";

const CancelDialog = ({ open, onClose, onConfirm, title, content, confirmText, cancelText }) => {
  if (!open) return null; 

  return (
    <div className="backdrop">
      <div className="dialog-container">
        <span className="dialog-title">{title || "Cancellation confirmation"}</span>
        <span className="horizontalLines"></span>
        <p className="dialog-content">
          {content || "Are you sure you want to cancel creating this plan? All unsaved changes will be lost."}
        </p>
        <div className="dialog-buttons">
          <button className="cancel-button" onClick={onClose}>
            {cancelText || "Go back"}
          </button>
          <button className="confirm-button" onClick={() => { onConfirm(); onClose(); }}>
            {confirmText || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelDialog;
